<template>
  <div>
    <div class="mt-4 d-flex align-items-start justify-content-between">
      <h1 class="page-title">{{ $t('Dashboard') }}</h1>
    </div>

    <div class="row">

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="card1Value"
          background-color="main-color"
          title="dashboard.card.title.operations.ongoing"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="card2Value"
          background-color="main-color"
          title="dashboard.card.title.lots.vente"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="card3Value"
          background-color="main-color"
          title="dashboard.card.title.operations.finished"/>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-12 mt-4 mb-4">
        <card-component
          :value="card4Value"
          background-color="secondary-color"
          title="dashboard.card.title.tasks.todo"/>
      </div>

    </div>

    <template v-for="alert in taskAlerts">
      <b-alert :variant="alert.style" class="my-1" dismissible show @dismissed="modifyAlertDate(alert.tasks)">
        <b-link v-if="alert.tasks.length === 1" @click="goToTask(alert.tasks)">
          {{ alert.element + ' ' + $t(alert.content) }}
        </b-link>
        <div v-else> {{ alert.element + ' ' + $t(alert.content) }}</div>
      </b-alert>
    </template>

    <dashboard-tasks-component/>

  </div>
</template>

<script>

import api from "../../services/api";
import CardComponent from "../../components/b122/CardComponent";
import DashboardTasksComponent from "./components/DashboardTasksComponent";
import FirstConnexionModal from "../user/FirstConnexionModal"

export default {
  name: "DashboardCollaborator",

  components: {
    CardComponent,
    DashboardTasksComponent,
    FirstConnexionModal
  },

  data() {
    return {
      card1Value: null,
      card2Value: null,
      card3Value: null,
      card4Value: null,
      isFirstConnexion: null,
      taskAlerts: []
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchDashboardData()
      this.fetchTaskAlerts()
    },

    fetchDashboardData() {
      api
        .get(`/dashboard/getDashboardCollaboratorInfos`)
        .then(response => {
          this.card1Value = response.data.card1Value
          this.card2Value = response.data.card2Value
          this.card3Value = response.data.card3Value
          this.card4Value = response.data.card4Value
          this.isFirstConnexion = response.data.isFirstConnexion
          if (this.isFirstConnexion) {
            this.showOnBoardingModal()
          }
        })
    },
    showOnBoardingModal() {
      this.$bvModal.show('first-connexion-modal')
    },

    async fetchTaskAlerts() {
      await api
        .get(`/operationTask/getAlertsForUser`)
        .then(response => {
          this.taskAlerts = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'Dashboard'
            })
          }
        })
    },

    goToTask(tasks) {
      if (tasks.length === 1) {
        this.$router.push({
          name: 'OperationTaskShow',
          params: {
            operationTaskId: tasks[0]
          }
        })
      } else {
        this.currentSection = 3
      }
    },

    async modifyAlertDate(tasksId) {
      let today = new Date()
      today.setHours(0, 0, 0)
      let tomorrow = today.getTime() + (24 + 9) * 60 * 60 * 1000
      for (const id of tasksId) {
        let data = new FormData()
        data.append('alertDate', tomorrow.toString())
        let url = '/operationTask/updateAlertDate/' + id

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
            this.$router.push({
              name: 'Dashboard'
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'Dashboard'
              })
            }
          })
      }
    },
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dashboard/DashboardCollaborator.vue